/* eslint-disable */
import axios from "axios";
import router from "@/router";
import cookies from "vue-cookies";
export default async function isLogin({next,to}) {
    if(cookies.get('jwt')){
        axios.defaults.headers={
            Authorization: cookies.get('jwt').token_type+" "+cookies.get('jwt').access_token
        }
    }
    
    await axios.get(process.env.VUE_APP_API_URL+"v1/ping")
    .then(response=>{
        if(response.status!==200){
            router.navigate("/");
        }
    })
    .catch(err=>{
        
        try{
            router.push("/");     
        }catch (e){
            
        }
    })
    return next();
}